const formatDateTime = (isoString) => {
  if (!isoString) {
    return '';
  }
  try {
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(isoString));
  } catch (error) {
    return isoString;
  }
};

const buildQuestionMap = (questions = {}) => {
  return Object.values(questions).reduce((map, question) => {
    if (question?.questionId) {
      map[question.questionId] = question;
    }
    return map;
  }, {});
};

const resolveRadioValue = (questionMap, questionId, value) => {
  if (!value) {
    return '';
  }

  const otherText = value.otherText && value.otherText.trim();
  if (otherText) {
    return otherText;
  }

  const selectedValue = value.selectedOptionValue;
  if (!selectedValue) {
    return '';
  }

  const optionLabel = questionMap[questionId]?.options?.find((option) => option.value === selectedValue)?.label;
  return optionLabel || selectedValue;
};

const resolveCheckboxValue = (questionMap, questionId, value) => {
  if (!value) {
    return '';
  }

  const otherText = value.otherText && value.otherText.trim();
  if (otherText) {
    return otherText;
  }

  const selectedValues = value.selectedOptionValues || [];
  if (!selectedValues.length) {
    return '';
  }

  const labels = selectedValues.map((val) => {
    const label = questionMap[questionId]?.options?.find((option) => option.value === val)?.label;
    return label || val;
  }).filter(Boolean);

  return labels.join(', ');
};

const getAnswerDisplay = (answer, questionMap) => {
  if (!answer) {
    return '';
  }

  const {fieldType, value, questionId} = answer;

  if (fieldType === 'text') {
    const text = value?.text;
    return text && text.trim() ? text.trim() : '';
  }

  if (fieldType === 'radio') {
    return resolveRadioValue(questionMap, questionId, value);
  }

  if (fieldType === 'checkbox') {
    return resolveCheckboxValue(questionMap, questionId, value);
  }

  return typeof value === 'string' ? value : '';
};

const getAnsweredQuestions = (form, questionMap) => {
  const orderedQuestions = Object.values(form?.formDefinitionSnapshot?.questions || {}).sort((a, b) => {
    const rankA = typeof a.rank === 'number' ? a.rank : Number.MAX_SAFE_INTEGER;
    const rankB = typeof b.rank === 'number' ? b.rank : Number.MAX_SAFE_INTEGER;
    return rankA - rankB;
  });

  return orderedQuestions.map((question) => {
    const answer = form?.answers?.[question.questionId];
    const displayValue = getAnswerDisplay(answer, questionMap);

    if (!displayValue) {
      return null;
    }

    return {
      question,
      displayValue,
    };
  }).filter(Boolean);
};

export {
  buildQuestionMap,
  formatDateTime,
  getAnswerDisplay,
  getAnsweredQuestions,
};
